import axios from "axios";
import { secureStorage } from "../utils/secureStorage.js";


const api = axios.create({
    //baseURL: process.env.REACT_APP_API_BASE_URL || "http://scholarapi.seasense.in/api",
     baseURL: process.env.REACT_APP_API_BASE_URL || "https://scholarbackend.seasensegroup.com/api",
    headers: {
        "Content-Type": "application/json",
        
    },
}); 

//  Request Interceptor (Attach Token)
api.interceptors.request.use(
    
    (config) => {
        const token = secureStorage.getToken(); 
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

//  Response Interceptor (Global Error Handling)
api.interceptors.response.use(
    (response) => response,
    (error) => {
         const url = error.config?.url || "";
        // ✅ Ignore forgot password APIs
    const isForgotApi =
      url.includes("/forgot/send-otp") ||
      url.includes("/forgot/verify-otp") ||
      url.includes("/forgot/reset-password");
      const isLoginApi =
  url.includes("/scholar/login");

    // ✅ Redirect only for protected APIs
    if (error.response?.status === 401 && !isForgotApi && !isLoginApi) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
         secureStorage.clear?.();
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);


export default api;

